document.querySelectorAll('.video-play-pause-btn').forEach((btn) => {
  const wrapper = btn.closest('.image-with-overlay-text');
  const videos = wrapper ? Array.from(wrapper.querySelectorAll('video')) : [];

  btn.addEventListener('click', () => {
    const isPlaying = btn.dataset.playing === 'true';
    videos.forEach((video) => {
      if (isPlaying) {
        video.pause();
      } else {
        video.play();
      }
    });
    btn.dataset.playing = isPlaying ? 'false' : 'true';
    btn.setAttribute('aria-label', isPlaying ? 'Play video' : 'Pause video');
  });
});
